import { Observable } from 'rxjs';

import { CoverageDeviceDebug } from './models';

export abstract class CoverageDeviceDebugApiService {
	public abstract getDebugDevice$(deviceId: string): Observable<CoverageDeviceDebug>;
}
